const DetailPageOffers = ({salarShoppingVouchers}: {salarShoppingVouchers: any |  undefined}) => {
  return (
    <>
      <div className=" display-max">
        <div className=" d-flex text-start justify-content-center align-items-center mb-2">
          <i className="fi fi-rr-badge-percent text-black me-1 fs-5"></i>{" "}
          <b className="fw-normal text-sm text-black">Offers</b>
        </div>
        <div className="pdp-promotion">
          <div className="pdp-promo-block">
            <div className="promo-blck">
              <div className="promo-title-blck ">
                <div className="promo-title">Use Salar Shopping Voucher</div>
                <div className="promo-tnc-blck">
                  <span className="promo-tnc text-success">
                    <a
                      href="#"
                      title="T&amp;C"
                      target="_blank"
                      aria-label="T&amp;C"
                    >
                      T&amp;C
                    </a>
                  </span>
                </div>
              </div>
              <div className="promo-desc-block ">
                <div className="promo-discounted-price  ">
                  <div>
                    Get it for{" "}
                    <span className="text-success fs-6 font-italic">{salarShoppingVouchers}</span>
                  </div>
                </div>
                <div className="promo-desc ">
                  Redeem Salar Shopping Voucher {salarShoppingVouchers} & Other Coupon Code Offers
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default DetailPageOffers;
